export default "__VITE_ASSET__D050f84b__"